import { TariffCategory, TariffStatusType } from '../../shared/models/types'
import { TariffDetailsDto } from '../api/dto/single-tariff.dto'
import { TariffDetailsModel } from '../models/single-tariff-model'
import { tariffStatus } from '../utils/tariff-status'

/**
 * Function for transforming single tariff dto model to front-end model
 * @param data - single tariff as TariffDetailsDto or undefined
 * @param isDynamicElectricityActive - boolean for dynamic electricity indicator
 * @returns - tariff as TariffDetailsModel
 */
export const tariffDetailsDtoToModel = (data: TariffDetailsDto | undefined, isDynamicElectricityActive: boolean): TariffDetailsModel => {
  return {
    currencyCode: data?.currencyCode ?? 'EUR',
    tariffName: data?.tariffName || '',
    tariffCategory: data ? data?.tariffCategory : TariffCategory.staticTariff,
    tariffStatus: data
      ? tariffStatus({
          start: new Date(data.start_date_time ?? ''),
          end: new Date(data.end_date_time ?? ''),
          isDynamicElectricityActive,
          tariffCategory: data?.tariffCategory,
        })
      : TariffStatusType.inactive,
    startTime: data?.start_date_time ? data.start_date_time : undefined,
    endTime: data?.end_date_time ? data.end_date_time : undefined,
    lastUpdated: data?.lastUpdated ? data.lastUpdated : undefined,
    solarPrice: data?.solarPrice || 0,
    dischargePrice: data?.dischargePrice || 0,
    staticGridPrice: data?.tariffElement ? data.tariffElement[0].price : 0,
    dynamicPrices:
      data?.tariffCategory === 'DYNAMIC' && data?.tariffElement
        ? data.tariffElement.map(tariffElement => {
            return {
              startDateTime: tariffElement.start_date_time,
              endDateTime: tariffElement.end_date_time,
              gridPrice: tariffElement.price,
              solarPrice: data.solarPrice || 0,
            }
          })
        : [],
  }
}
